// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2CIXIYB0caKpeb5T3QE42E","row":"dzXKX1eReJac01ZDD1vsr","field":"befaYpmTtAf1KXgs_N9ey","label":"_2cXs_e98FRkUCrgi3ha3dI"};